import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistDataFlowService} from '../services/specialist-data-flow.service';

@Component({
    selector: 'app-specialist-view-tab-clothes',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <h3>Размеры спецодежды</h3>
        <p>
            <a href="javascript:;" (click)="onAddClick()">Добавить сведения о спецодежде</a>
        </p>

        <ng-container *ngIf="hasGear()">
            <table class="view-info-table">
                <thead>
                    <tr>
                        <th style="width: 150px">Тип спецодежды</th>
                        <th>Размер</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngIf="specialist.height">
                        <td>
                            Рост
                        </td>
                        <td>
                            {{specialist.height}}
                        </td>
                    </tr>
                    <tr *ngIf="specialist.clothing_size_title">
                        <td>
                            Одежда
                        </td>
                        <td>
                            {{specialist.clothing_size_title}}
                        </td>
                    </tr>
                    <tr *ngIf="specialist.headgear_size_title">
                        <td>
                            Головной убор
                        </td>
                        <td>
                            {{specialist.headgear_size_title}}
                        </td>
                    </tr>
                    <tr *ngIf="specialist.shoe_size_title">
                        <td>
                            Обувь
                        </td>
                        <td>
                            {{specialist.shoe_size_title}}
                        </td>
                    </tr>
                    <tr *ngIf="specialist.glove_size_title">
                        <td>
                            Перчатки
                        </td>
                        <td>
                            {{specialist.glove_size_title}}
                        </td>
                    </tr>
                    <tr *ngIf="specialist.pants_size_title">
                        <td>
                            Штаны
                        </td>
                        <td>
                            {{specialist.pants_size_title}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    `
})

export class SpecialistViewTabClothesComponent {
    @Input() specialist: SpecialistViewInterface;

    constructor(
        private dataService: SpecialistDataFlowService,
    ) {
    }

    onAddClick() {
        this.dataService.addClothesSizes$.next();
    }

    hasGear() {
        return Boolean(
            this.specialist.clothing_size_title ||
            this.specialist.headgear_size_title ||
            this.specialist.glove_size_title ||
            this.specialist.pants_size_title ||
            this.specialist.shoe_size_title
        );
    }
}
